import { render, staticRenderFns } from "./SearchBar.vue?vue&type=template&id=5b808d1e&scoped=true&"
import script from "./SearchBar.vue?vue&type=script&lang=ts&"
export * from "./SearchBar.vue?vue&type=script&lang=ts&"
import style0 from "./SearchBar.vue?vue&type=style&index=0&id=5b808d1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b808d1e",
  null
  
)

export default component.exports